import { render, staticRenderFns } from "./singleQueue.vue?vue&type=template&id=7beeb7da&scoped=true&"
import script from "./singleQueue.vue?vue&type=script&lang=js&"
export * from "./singleQueue.vue?vue&type=script&lang=js&"
import style0 from "./singleQueue.vue?vue&type=style&index=0&id=7beeb7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beeb7da",
  null
  
)

export default component.exports